// extracted by mini-css-extract-plugin
export default {"sr-only":"Checkbox__sr-only--UAw5m Accessibility__sr-only--Jea6c","default":"Checkbox__default--SIFNp"};